// Loading skeletons built on the existing `.skeleton` shimmer class (which was
// defined in index.css but used nowhere). These replace full-page spinners.

export function Skeleton({ className = '' }) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />;
}

// A card placeholder that mirrors the common image-over-text card layout used
// by menu items, branches, and news.
export function CardSkeleton() {
  return (
    <div className="card">
      <Skeleton className="aspect-[4/3] w-full rounded-none" />
      <div className="p-4 space-y-3">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    </div>
  );
}

// A responsive grid of card skeletons for list pages.
export function SkeletonGrid({ count = 8, className = 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6' }) {
  return (
    <div className={className} role="status" aria-busy="true">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}
